import { useEffect } from 'react';
import { useAudio } from '../../../../../contexts';
import { convertPositionToSec } from '../components/AudioThumb/utils';
import { useContainerBoundaries } from './useContainerBoundaries';
export function useMouseMove(isDragging, mouseRelativeToThumb, containerRef) {
  var _useAudio = useAudio(),
      seek = _useAudio.seek,
      duration = _useAudio.duration;

  var containerDim = useContainerBoundaries(containerRef);
  /**
   * Updating Thumb position according to the current mouse position (only when Thumb is being dragged)
   */

  useEffect(function () {
    var handleMouseMove = function handleMouseMove(e) {
      if (isDragging) {
        e.preventDefault();
        var mouseX = e.clientX - mouseRelativeToThumb.current;
        var position = convertPositionToSec(mouseX, containerDim, duration);
        seek(position);
      }
    };

    document.addEventListener('mousemove', handleMouseMove);
    return function () {
      return document.removeEventListener('mousemove', handleMouseMove);
    };
  }, [isDragging, mouseRelativeToThumb, containerDim, seek, duration]);
}